import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import ReactHtmlParser from 'react-html-parser';
import ReactOembedContainer from 'react-oembed-container';
import ArchieElement from './ArchieElement';
import VideoPlayerElement from './VideoPlayerElement';

const BodyElement = ({ data }) => {
  switch (data.type) {
    case 'text': {
      return (
        <p className="introtext">
          {ReactHtmlParser(data.content)}
        </p>
      );
    }
    case 'image': {
      return (
        <img
          src={data.url}
          srcSet={data.srcSet}
          alt={data.caption}
        />
      );
    }
    case 'video': {
      return (
        <React.Fragment>
          <h1>Video Below</h1>
          <VideoPlayerElement data={data} />
        </React.Fragment>
      );
    }
    case 'quote': {
      const contentElements = get(data, 'content_elements', []);
      return (
        <blockquote className={data.subtype}>
          {contentElements.map((element) => (
            <BodyElement data={element} key={element._id} />
          ))}
          <cite>{get(data, 'citation.content')}</cite>
        </blockquote>
      );
    }
    case 'interstitial_link': {
      return (
        <a href={data.url} target="_blank" rel="nofollow noreferrer">
          {ReactHtmlParser(data.content)}
        </a>
      );
    }
    case 'oembed_response': {
      const html = get(data, 'raw_oembed.html', '');
      return (
        <ReactOembedContainer markup={html}>
          {ReactHtmlParser(html)}
        </ReactOembedContainer>
      );
    }
    case 'custom_embed': {
      if (data.subtype === 'archieml') {
        return <ArchieElement data={data} />;
      }
      return null;
    }
    default: {
      return null;
    }
  }
};

BodyElement.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.string,
    embed: PropTypes.shape({ config: PropTypes.shape({ data: PropTypes.string }) }),
    raw_oembed: PropTypes.shape({ html: PropTypes.string }),
    embed_html: PropTypes.string,
    content_elements: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string,
      content: PropTypes.string,
      type: PropTypes.string,
    })),
    citation: PropTypes.shape({ content: PropTypes.string }),
  }).isRequired,
};

export default BodyElement;
